// extracted by mini-css-extract-plugin
export default {"grid":"PairsPage_grid__wHE8d","toolbar":"PairsPage_toolbar__UZASa"};